import Vue from 'vue'
import vuetify from './plugins/vuetify'
import '@/styles/index.scss'
import App from './App.vue'
import store from './store'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css';
import VueGeolocation from 'vue-browser-geolocation';

Vue.use(Vant)
Vue.use(VueGeolocation)


Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
